import { gql } from '__generated__';

export default gql(`
  mutation ActivateInvitation($id: ID!) {
    activateInvitation(id: $id) {
      id
      active
    }
  }
`);
